module.exports = __webpack_public_path__ + "img/google-play-link.0fdc53fb.svg";